{
  "Settings": "Ajustes",
  "Open Settings": "Abrir Ajustes",
  "Go Live": "Emitir en directo",
  "Watch Live": "Ver en directo",
  "Live only": "Solo en directo",
  "Sell Tickets": "Vender entradas",
  "Video Wall": "Muro de vídeos",
  "Manage Video": "Gestionar vídeo",
  "Upload video": "Subir vídeo",
  "h:mm A": "H:mm",
  "h:mm a": "H:mm"
}
